export const notification = {
  notification: 'Obavijesti',
  allNotifications: 'Sve obavijesti',
  general: 'Opće',
  settings: 'Postavke',
  newChatRequest: {
    youHaveANewChatRequest: 'Imate novi zahtjev za razgovor!!!',
    youHaveTransferredChatRequest: 'Imate preneseni zahtjev za razgovor!!!',
    acceptRequest: 'Prihvati zahtjev',
    discardRequest: 'Odbaci zahtjev'
  },
  notificationList: {
    name: 'Ime',
    message: 'Poruka',
    noDataFound: {
      notification: 'Obavijest',
      noNotificationsFound: 'Nema pronađenih obavijesti!',
    }
  },
  notificationSetting: {
    userMessage: 'Korisnička poruka',
    receiveNotificationsWhenUserSendMessage: 'Primate obavijesti kada bilo koji korisnik pošalje poruku',
    liveChatRequest: 'Zahtjev za live chat',
    receiveNotificationsWhenUserRequestLiveChat: 'Primate obavijesti kada bilo koji korisnik zatraži live chat',
    newLead: 'Novi kontakt',
    receiveNotificationsWhenNewLeadCreated: 'Primate obavijesti kada se stvori novi kontakt',
    assignedOnly: 'Samo dodijeljeni',
    allUsers: 'Svi korisnici',
    customizeWhichNotificationsYouWantToReceive: 'Prilagodite koje obavijesti želite primati',
    youCanCustomizeSettingForTheNotifications: 'Možete prilagoditi postavke za obavijesti',
    receiveNotifications: 'Primi obavijesti',
    desktopNotifications: 'Obavijesti na radnoj površini',
    mobilePushNotifications: 'Obavijesti putem mobilnog uređaja',
    discard: 'Odbaci',
    update: 'Ažuriraj',
    appTooltip: {
      TOOLTIP_NEW_MESSAGE_DESKTOP_NOTIFICATION: 'Pošalji obavijesti o novoj poruci na radnu površinu',
      TOOLTIP_NEW_MESSAGE_MOBILE_NOTIFICATION: 'Pošalji obavijesti o novoj poruci putem mobilnog uređaja',
      TOOLTIP_NEW_LEAD_DESKTOP_NOTIFICATION: 'Pošalji obavijesti o novom kontaktu na radnu površinu',
      TOOLTIP_NEW_LEAD_MOBILE_NOTIFICATION: 'Pošalji obavijesti o novom kontaktu putem mobilnog uređaja',
      TOOLTIP_LIVE_CHAT_DESKTOP_NOTIFICATION: 'Pošalji obavijesti o live chatu na radnu površinu',
      TOOLTIP_LIVE_CHAT_MOBILE_NOTIFICATION: 'Pošalji obavijesti o live chatu putem mobilnog uređaja',
      TOOLTIP_RECEIVED_NOTIFICATION: 'Odaberite za koje poruke želite primiti obavijesti'
    }
  }
};

